import { useMemo } from 'react';

import { createBrowserHistory, createMemoryHistory } from 'history';
import { useLocation, useRouteMatch } from 'react-router-dom';

import { getStore } from '../../../../init-store';
import { getPath } from '../get-path';
import { createLogger } from '../loggerFacade';
import { bugFormController } from '../yndx-bug';
import { SCREENS } from './routing';
import { navigateAction } from './slice';
import type { NavigateFunction, NavigationParams, UseNavigationEffect } from './types';

export { SCREENS } from './routing';

const logger = createLogger('navigation');

export const history = NODE ? createMemoryHistory() : createBrowserHistory();

export const initHistoryListener = () => {
    history.listen((location, action) => {
        logger.event('History location changed', {
            additional: {
                action,
                location,
            },
        });
    });
};

export const getUrl = (screen: SCREENS, params: NavigationParams = {}) => {
    const path = (() => {
        switch (screen) {
            case SCREENS.CALL:
                return `/j/${params.id}`;
            case SCREENS.CREATE_CALL:
                return '/';
            case SCREENS.CONNECT_CALL:
                return '/connect-to-meeting-by-id';
            case SCREENS.PLAN_CALL:
                return '/planning';
            case SCREENS.PLAN_BROADCAST:
                return '/broadcast-planning';
            case SCREENS.CREATE_BROADCAST:
                return '/create-broadcast';
            case SCREENS.CONFERENCES_HISTORY:
                return '/conferences-history';
            default:
                return '/';
        }
    })();
    return `${path}${params.searchString || ''}`;
};

export const getShortUrlId = () => {
    const [, shortUrlId] = history.location.pathname.match(/\/j\/(.*)$/) || [];

    return shortUrlId || 'unknown';
};

// В общем-то это достаточно грязный хак, позволяющий из enum получить массив значений
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const screensArray: SCREENS[] = Object.keys(SCREENS).map((s) => (SCREENS as any)[s] as SCREENS);

const getScreenByUrl = (params: NavigationParams): SCREENS | undefined => {
    return screensArray.find((screen) => getUrl(screen, params));
};

const updateUrlForBug = (url: string) => {
    bugFormController.setData({
        meeting_url: url,
        meeting_problem: url,
    });
};

export const navigate: NavigateFunction = (screen, params = {}) => {
    const url = getUrl(screen, params);
    history?.push(getPath(url), params);
    getStore().dispatch(navigateAction(screen));
    updateUrlForBug(url);
};

export const replace: NavigateFunction = navigate;

export const useNavigation: UseNavigationEffect = () => {
    const match = useRouteMatch();
    const searchString = useLocation().search;

    return useMemo(() => {
        return {
            navigate,
            replace,

            route: {
                url: match.url,
                screen: getScreenByUrl(match.params),
                params: {
                    ...match.params,
                    searchString,
                },
            },
        };
    }, [match.params, match.url, searchString]);
};
